import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AppUpdateHinweis } from './components/AppUpdateHinweis';
import { registriereServiceWorker } from './serviceWorker';
import './styles.css';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<App />
		<AppUpdateHinweis />
	</StrictMode>
);

registriereServiceWorker();
